var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1498 13.851C2.40807 13.5617 4.14319 12.199 5.00562 11.5272C5.31972 11.2826 5.70501 11.151 6.10316 11.151C7.0659 11.151 8.92111 11.151 9.88849 11.151C10.2913 11.151 10.6804 11.2882 11.0047 11.5271C12.1183 12.3474 13.1623 12.9587 14.2998 13.851M3.4998 15.2008H12.4998C13.991 15.2008 15.1998 13.9919 15.1998 12.5008V3.50078C15.1998 2.00961 13.991 0.800781 12.4998 0.800781H3.4998C2.00864 0.800781 0.799805 2.00961 0.799805 3.50078V12.5008C0.799805 13.9919 2.00864 15.2008 3.4998 15.2008ZM10.5787 5.95481C10.5787 4.58118 9.41912 3.45884 7.9998 3.45884C6.58052 3.45884 5.42089 4.58118 5.42089 5.95481C5.42089 7.32845 6.58052 8.45078 7.9998 8.45078C9.41908 8.45078 10.5787 7.32845 10.5787 5.95481Z",
    stroke: "#616874",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarContact);
export default __webpack_public_path__ + "static/media/calendarContact.ad34b11091ddbef3c2b9cfd2607d539b.svg";
export { ForwardRef as ReactComponent };